import { render, staticRenderFns } from "./ImportSettings.vue?vue&type=template&id=64c00c7c&scoped=true"
import script from "./ImportSettings.vue?vue&type=script&lang=js"
export * from "./ImportSettings.vue?vue&type=script&lang=js"
import style0 from "./ImportSettings.vue?vue&type=style&index=0&id=64c00c7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c00c7c",
  null
  
)

export default component.exports